<template>
  <div id="app" @contextmenu="rightClick">
    <router-view :class="'router-view'"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',

  methods: {
    rightClick (e) {
      e.preventDefault()
    }
  }
}
</script>

<style lang="scss">
  @import 'static/pikaday';

  #app {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height:100%;
  }

  .router-view {
    height: 100%;
  }

  img {
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue